/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { ErrorBoundary } from 'components';
import SectionLayout from 'components/common/SectionLayout';
import * as S from './TargetingOngoingLanguages.styled';
import Separator from 'components/common/Separator.js';
import ChooseLangBtn from './chooseLangBtn/ChooseLangBtn';
import FillLangsBtn from './fillBtn/FillLangsBtn';
import { useFacade } from './useFacade';
import { Buttons, ErrorForBtn, RadioBox, Label } from 'components';
import SelectedLang from './SelectedLang';
import { targetingLanguagesActions, targetingPlacementsActions } from 'store/actions';
import { select_targeting_languages_tubs, selectTargettingErrorFlag } from 'store/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { RadioBoxGroup, RightSideContainer } from '../components/';
import { alphabeticallySort } from 'utils';

function TargetingOngoingLanguages() {
  const dispatch = useDispatch();
  const errorFlag = useSelector(selectTargettingErrorFlag);
  const selecteTub = useSelector(select_targeting_languages_tubs);
  const { selectedLangs, langCodeToData, upDateStore, deleteLangBtn } = useFacade();

  const handleChange = (newValue) => {
    if (newValue === selecteTub) return;
    dispatch(targetingLanguagesActions.changeLanguagesTargetingType(newValue));
    if (selectedLangs.length) {
      upDateStore();
    }
    if (errorFlag.languages) {
      dispatch(
        targetingPlacementsActions.updateErrorField({
          errorField: 'languages',
          newValue: false,
        }),
      );
    }
  };

  useEffect(() => {
    if (selectedLangs.length) {
      dispatch(targetingLanguagesActions.changeLanguagesTargetingType('specific_languages'));
    }
  }, []);

  return (
    <ErrorBoundary>
      <SectionLayout
        noSeparator={true}
        noBottomPadding={true}
        leftSide={<Label text='Languages:' variant='label' style={{ marginTop: '8px' }} />}
        rightSide={
          <RightSideContainer>
            <RadioBoxGroup>
              <RadioBox.NormalSize
                onChange={handleChange}
                label='All Languages'
                width={137}
                variant='left'
                value='all_languages'
                pressed={selecteTub === 'all_languages'}
              />
              <RadioBox.NormalSize
                onChange={handleChange}
                label='Specific Languages'
                width={170}
                variant='right'
                value='specific_languages'
                pressed={selecteTub === 'specific_languages'}
              />
            </RadioBoxGroup>
            {selecteTub !== 'all_languages' && (
              <>
                <S.Container showBorder={errorFlag.languages}>
                  <S.BtnWrapp>
                    <ChooseLangBtn />
                    <FillLangsBtn selectedLangs={selectedLangs} upDateStore={upDateStore} />
                  </S.BtnWrapp>
                  {selectedLangs.length ? (
                    <>
                      <Separator />
                      <S.SelectedItems>
                        <Buttons.TertiaryNormal id='choose_apps_clear_all' onClick={upDateStore}>
                          Clear All
                        </Buttons.TertiaryNormal>
                        <S.SelectedItemsList>
                          {[...selectedLangs]?.sort(alphabeticallySort(''))?.map((langCode) => {
                            return (
                              <SelectedLang
                                key={langCode}
                                langCode={langCode}
                                language_name={langCodeToData[langCode]}
                                deleteLangBtn={deleteLangBtn}
                              />
                            );
                          })}
                        </S.SelectedItemsList>
                      </S.SelectedItems>
                    </>
                  ) : null}
                </S.Container>
                <ErrorForBtn
                  errorMsg='Please choose Languages or select "All Languages".'
                  isOpen={errorFlag.languages}
                />
              </>
            )}
          </RightSideContainer>
        }
      />
    </ErrorBoundary>
  );
}

export default TargetingOngoingLanguages;
